import type { IUser } from '../../../Model/index.ts'
import { Navigate } from 'react-router-dom'
import { canUseOrderWizard } from '../../../Model/User/featureGating.ts'
import { ProtectedRoute } from '../../Layout/ProtectedRoute/ProtectedRoute.tsx'
import { clearOrderWizardStorage } from '../../../Services/OrderWizard/draftStorage.ts'
import { clearWizardHandoff } from '../../../Services/OrderWizard/handoff.ts'
import { OrderWizardPage } from './OrderWizardPage.tsx'
import { ClassicCreateEntry, DashboardEntry, ORDER_WIZARD_PATH } from './EntryPoints.tsx'

/*
 * The wizard's route, entry points and logout cleanup. The store registers the slice and epics from
 * Flux/{Slice,Epic}/OrderWizard instead: importing this module there would import the store from itself.
 */

export const orderWizardRoute = (user: IUser | null) => ({
  path: ORDER_WIZARD_PATH,
  element: (
    <ProtectedRoute user={user}>{canUseOrderWizard(user) ? <OrderWizardPage /> : <Navigate to="/home" replace />}</ProtectedRoute>
  )
})

/** The drop area on top of the classic lab create page; renders nothing for users it is not for. */
export const OrderWizardCreatePageEntry = ClassicCreateEntry

/** Wraps the dashboard's "Create order" options: the FASTQ option takes file drops, a line under them picks files. */
export const OrderWizardDropTarget = DashboardEntry

/** Drafts are kept per user in the browser; a logout lets them go, with any files still being handed over. */
export const clearOrderWizardOnLogout = () => {
  clearWizardHandoff()
  clearOrderWizardStorage()
}
